export default __webpack_public_path__ + "static/jobs-7d2200c7c09aa7db3464d14393cd83ab.jpg";